module.exports = __webpack_public_path__ + "ef386cf9a32cc2013c36d04a85859dfb.jpg";